import female from 'assets/images/femenine Inactive.svg';
import male from 'assets/images/male.svg';
import others from 'assets/images/Others.svg';
import activeFemale from 'assets/images/femenine active.svg';
import activeMale from 'assets/images/Male Active.svg';
import activeOther from 'assets/images/homosexual Active.svg'

export const registrationForm = [
    {
      fullName: [
        {
          placeholder: "First name",
          required: true,
          type: "text",
          name: "firstname",
          label: "First Name",
          maxlength:30,
        },
        {
          placeholder: "Last name",
          required: false,
          type: "text",
          name: "lastname",
          label: "Last Name",
          maxlength:30,
        },
      ],
    },
    {
      placeholder: "Email",
      required: true,
      type: "text",
      name: "email",
      label: "Email",
      maxlength:100,
    },
    { 
      placeholder: "Mobile Number",
      required: true,
      type: "number",
      name: "number",
      label: "Mobile Number",
      countrycode: true,
      maxlength:10,     
    },
    {
      placeholder: "Gender",
      required: true,
      type: "button",
      name: "gender",
      label: "Gender",
      button: [
        { label:"Female", name: "Female", value: "female", image: female, activeImg:activeFemale},
        { label:"Male", name: "Male", value: "male", image: male, activeImg:activeMale},
        { label:"Others", name: "Others", value: "others", image: others, activeImg:activeOther}
      ],
    },
    {
      type:"checkbox",
    }
  ];
  export const loginForm = [
    {
      placeholder: 'Mobile Number',
      required: true,
      type: 'number',
      name: 'mobile',
      label: 'Mobile Number',
      star: '*',
      countrycode: false,
    },
  ];
